import { useCallback as n } from "react";
import { vehicleTrafficVolumeDefaultVisualFilter as me, vehicleTrafficVolumeNewInrixDefaultFetchFilter as ye } from "./index.es99.js";
import "react/jsx-runtime";
import "./index.es4.js";
import "./index.es20.js";
import { usePLMapboxLayersStore as L } from "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import { getTradeAreaLayerColorIndicator as v, getTradeAreaLayerDescription as g } from "./index.es254.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import { chainVenuesDefaultVisualFilters as Ce, chainVenuesDefaultFetchFilters as fe } from "./index.es76.js";
import "geobuckets";
import "@deck.gl/layers/typed";
import "@placer-ui/components";
import "react-map-gl";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "use-debounce";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es204.js";
import "./index.es235.js";
import "@sentry/react";
import { useUpdateToPOICombinedLayersData as ve } from "./index.es255.js";
import "./index.es207.js";
import "./index.es59.js";
import { convertColorPaletteToLegendItems as b } from "./index.es66.js";
import { getTheNextFreePaletteColors as T } from "./index.es67.js";
import { POICalloutDefaultVisualFilter as P, POICalloutDefaultFetchFilter as ge, defaultPOICalloutBoxConfig as be } from "./index.es74.js";
import "./index.es43.js";
import { distanceInMilesDefaultVisualFilter as Te } from "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import { driveTimeDefaultVisualFilter as Fe } from "./index.es84.js";
import "./index.es23.js";
import { usePLMapboxDeckActions as he } from "./index.es24.js";
import "./index.es18.js";
import { NearbyDefaultVisualFilter as Le, NearbyDefaultFetchFilter as xe } from "./index.es72.js";
import "@deck.gl/geo-layers/typed";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "lodash/fp";
import "./index.es91.js";
import "./index.es92.js";
import { trueTradeAreaDefaultVisualFilter as V, trueTradeAreaDefaultFetchFilter as A } from "./index.es78.js";
import "@deck.gl/core/typed";
import { ttaHeatMapDefaultVisualFilter as w } from "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import { walkTimeDefaultVisualFilter as De } from "./index.es86.js";
import { TextboxDefaultVisualFilter as G, TextboxDefaultFetchFilter as Me } from "./index.es101.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "lodash";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import { getChainVenuesColor as O } from "./index.es256.js";
import { tagsDefaultVisualFilter as Pe, tagsDefaultFetchFilter as Ve } from "./index.es257.js";
import { useAddBoundaryPolygonLayer as ke } from "./index.es258.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import "./index.es203.js";
import "./index.es205.js";
import "./index.es206.js";
import { visualFilterDictionary as Be, fetchFilterDictionary as Se } from "./index.es110.js";
import N from "./index.es240.js";
const Wo = () => {
  const {
    deleteLayerGroup: k,
    addLayerGroup: u,
    updateLayerGroup: B,
    addSubLayer: c,
    updateSubLayer: C,
    deleteSubLayer: x,
    setCombinedLayersStatus: U,
    setCombinedLayersData: H,
    setLayersData: j,
    ...q
  } = L((e) => e.actions), S = ke(), { removeAllDeckLayersConnectingToLayerId: F } = he(), _ = ve(), h = n(
    ({
      mapId: e,
      poiId: t,
      poiType: o,
      name: r,
      description: i
    }) => u({
      mapId: e,
      renderType: "poi-group",
      name: r,
      description: i,
      layerColor: void 0,
      visible: !0,
      fetchFilter: {
        poiId: t,
        poiType: o
      },
      visualFilter: void 0,
      subLayerConfig: {}
    }),
    [u]
  ), f = n(
    ({
      mapId: e,
      layerGroupId: t,
      name: o,
      visible: r = !0,
      includeTenants: i = !0,
      poiCalloutBoxConfig: l,
      addBoundaryLayer: a,
      boundaryPolygonLayerName: s = "Property Boundary",
      boundaryPolygonVisualFilter: p
    }) => {
      const d = c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "poi-callout",
          name: o,
          description: void 0,
          layerColor: P.poiCalloutBoxConfig.headerContainerColor,
          visible: r,
          fetchFilter: {
            ...ge,
            includeTenants: i
          },
          visualFilter: {
            ...P,
            poiCalloutBoxConfig: {
              ...P.poiCalloutBoxConfig,
              ...l
            }
          }
        }
      });
      return a && S({
        mapId: e,
        layerGroupId: t,
        visible: !0,
        name: s,
        visualFilter: {
          ...p
        }
      }), d;
    },
    [c, S]
  ), W = n(
    ({
      mapId: e,
      layerGroupId: t,
      subLayerId: o,
      poiCalloutBoxConfig: r,
      addBoundaryLayer: i = !1
    }) => {
      var s, p, d, m, y, D, M;
      const l = {
        ...(M = (D = (y = (m = (d = (p = (s = L.getState().maps) == null ? void 0 : s[e]) == null ? void 0 : p.layerGroupConfig) == null ? void 0 : d[t]) == null ? void 0 : m.subLayerConfig) == null ? void 0 : y[o]) == null ? void 0 : D.visualFilter) == null ? void 0 : M.poiCalloutBoxConfig
      };
      delete l.showHeader, delete l.showLogo, delete l.showPropertyName, delete l.showPropertyAddress, delete l.showMetrics;
      const a = f({
        mapId: e,
        layerGroupId: t,
        name: "Shopping Center Callout Box",
        includeTenants: !1,
        poiCalloutBoxConfig: r || l,
        addBoundaryLayer: i
      });
      C({
        mapId: e,
        layerGroupId: t,
        subLayerId: o,
        name: "Tenant Callout Box",
        visualFilter: {
          tenantsCalloutBoxSubLayerId: a
        }
      });
    },
    [f, C]
  ), E = n(
    ({
      mapId: e,
      layerGroupId: t,
      subLayerId: o
    }) => {
      var i, l, a, s, p, d, m;
      const r = (m = (d = (p = (s = (a = (l = (i = L.getState().maps) == null ? void 0 : i[e]) == null ? void 0 : l.layerGroupConfig) == null ? void 0 : a[t]) == null ? void 0 : s.subLayerConfig) == null ? void 0 : p[o]) == null ? void 0 : d.visualFilter) == null ? void 0 : m.tenantsCalloutBoxSubLayerId;
      r && (x({
        mapId: e,
        layerGroupId: t,
        subLayerId: r
      }), C({
        mapId: e,
        layerGroupId: t,
        subLayerId: o,
        name: "Tenants Callout Box",
        visualFilter: {
          tenantsCalloutBoxSubLayerId: void 0
        }
      }));
    },
    [x, C]
  ), J = n(
    ({
      mapId: e,
      name: t,
      formattedAddress: o,
      geolocation: r,
      autoComputeVisits: i = !1,
      loadingStatus: l = "loading"
    }) => {
      const a = u({
        mapId: e,
        renderType: "tmp-cpoi-group",
        name: t,
        description: o,
        layerColor: void 0,
        visible: !0,
        fetchFilter: {},
        visualFilter: {},
        subLayerConfig: {}
      }), s = f({
        mapId: e,
        layerGroupId: a,
        name: "Callout Box",
        poiCalloutBoxConfig: {
          showMetrics: !1,
          showMetricsVisits: i
        },
        addBoundaryLayer: !1
      }), p = `temp-custompoiid-${N()}`;
      return _({
        mapId: e,
        layerGroupId: a,
        subLayerId: s,
        calloutBoxPOIInfo: [{
          poiId: p,
          poiType: "complex",
          geolocation: r,
          logoImgURL: void 0,
          logoImgBlob: void 0,
          categorySVGURL: void 0,
          rankMetric: void 0,
          visitMetric: {
            label: "Visits",
            value: "",
            isRestricted: !1
          },
          visitorsMetric: void 0,
          visitFrequencyMetric: void 0,
          dwellTimeMetric: void 0,
          salesMetric: void 0,
          salesSqFtMetric: void 0,
          transactionsMetric: void 0,
          popstatsPopulationMetrics: void 0,
          censusPopulationMetrics: void 0,
          mosaicPopulationMetrics: void 0,
          personaLiveMetrics: void 0,
          visitsAudienceMetrics: void 0,
          marketPopulationMetrics: void 0,
          marketEmployeesMetrics: void 0,
          marketCensusMetrics: void 0,
          marketPopstatsMetrics: void 0,
          marketDemographicAudience: void 0,
          marketWorkforceAudience: void 0,
          mainHeader: t,
          subHeader: o,
          category_info: {
            group: "Address",
            primary: "Address",
            sub_category: "Address"
          },
          verified: void 0,
          tenants: [],
          tenantsGroupBox: {
            totalTenantCount: 0,
            top20UniqueTenantLogos: [],
            allUniqueTenants: []
          },
          entity_section: "property"
        }],
        styleConfig: {
          ...be,
          showMetrics: !1,
          showMetricsVisits: i
        },
        visible: !0,
        isGrouped: !0,
        isUngroupedDisabled: !1,
        loadingStatus: l
      }), {
        layerGroupId: a,
        subLayerId: s,
        tempPoiId: p
      };
    },
    [u, f, _]
  ), z = n(
    ({ mapId: e, visible: t }) => u({
      mapId: e,
      renderType: "nearby",
      name: "Nearby Properties",
      description: void 0,
      layerColor: void 0,
      visible: t,
      fetchFilter: xe,
      visualFilter: Le,
      subLayerConfig: {}
    }),
    [u]
  ), R = n(
    ({ mapId: e }) => u({
      mapId: e,
      renderType: "nearmap",
      name: "Nearmap",
      description: void 0,
      layerColor: void 0,
      visible: !0,
      fetchFilter: {
        orientation: "Vert"
      },
      visualFilter: void 0,
      subLayerConfig: {}
    }),
    [u]
  ), $ = n(
    ({
      mapId: e,
      visible: t,
      text: o,
      geolocation: r
    }) => {
      var l, a;
      const i = (a = (l = L.getState().maps) == null ? void 0 : l[e].lastUpdatedStyle) == null ? void 0 : a.textbox;
      return u({
        mapId: e,
        renderType: "textbox",
        name: "Text",
        description: void 0,
        visible: t,
        fetchFilter: {
          ...Me,
          poiId: N()
        },
        visualFilter: {
          ...G,
          text: o.trim(),
          geolocation: r,
          textboxStyleConfig: {
            ...G.textboxStyleConfig,
            ...i
          }
        },
        subLayerConfig: {}
      });
    },
    [u]
  ), I = n(
    ({ mapId: e, visible: t, layerType: o }) => u({
      mapId: e,
      renderType: "thematic",
      visible: t,
      name: void 0,
      description: void 0,
      layerColor: void 0,
      fetchFilter: void 0,
      visualFilter: { layerType: o },
      subLayerConfig: {}
    }),
    [u]
  ), K = n(
    ({
      mapId: e,
      geojson: t,
      name: o = "GeoJSON",
      visible: r = !0
    }) => u({
      mapId: e,
      renderType: "static-geojson",
      name: o,
      description: void 0,
      layerColor: void 0,
      visible: r,
      fetchFilter: {
        geojson: t
      },
      visualFilter: void 0,
      subLayerConfig: {}
    }),
    [u]
  ), Q = n(
    ({
      mapId: e,
      geojson: t,
      name: o = "GeoJSON",
      visible: r = !0
    }) => u({
      mapId: e,
      renderType: "draw-polygon-geojson",
      name: o,
      description: void 0,
      layerColor: void 0,
      visible: r,
      fetchFilter: {
        geojson: t
      },
      visualFilter: {},
      subLayerConfig: {}
    }),
    [u]
  ), X = n(
    ({
      mapId: e,
      name: t,
      description: o,
      tagId: r
    }) => {
      const i = O(e);
      return u({
        mapId: e,
        renderType: "tags",
        name: t,
        description: o,
        layerColor: i.color,
        visible: !0,
        fetchFilter: {
          ...Ve,
          tagId: r
        },
        visualFilter: {
          ...Pe,
          palette: i.palette,
          pinPalette: i.palette
        },
        subLayerConfig: {}
      });
    },
    [u]
  ), Y = n(
    ({
      mapId: e,
      name: t,
      visible: o,
      fetchFilter: r,
      visualFilter: i
    }) => u({
      mapId: e,
      renderType: "vtv",
      name: t,
      description: void 0,
      layerColor: void 0,
      visible: o,
      fetchFilter: {
        ...ye,
        ...r
      },
      visualFilter: {
        ...me,
        ...i
      },
      subLayerConfig: {}
    }),
    [u]
  ), Z = n(
    ({
      mapId: e,
      layerGroupId: t,
      ringRadius: o,
      entity_id: r,
      entity_type: i,
      includeLabel: l = !0
    }) => {
      const a = T({
        mapId: e,
        category: "trade-area",
        bucket: o.length,
        layerGroupId: t
      }), s = {
        ...a,
        paletteColors: [...a.paletteColors].reverse()
      }, p = b(s, o), { layerColor: d, layerGradient: m } = v({
        items: p,
        type: "distance_in_miles",
        paletteColors: s.paletteColors
      }), y = g({ items: p, type: "distance_in_miles" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "distance_in_miles",
          name: "Distance in Miles",
          description: y,
          layerColor: d,
          layerGradient: m,
          visible: !0,
          fetchFilter: {
            ringRadius: o,
            entity_id: r,
            entity_type: i
          },
          visualFilter: {
            ...Te,
            palette: s,
            items: p,
            includeLabel: l
          }
        }
      });
    },
    [c]
  ), ee = n(
    ({
      mapId: e,
      layerGroupId: t,
      timeSelected: o,
      entity_id: r,
      entity_type: i
    }) => {
      const l = T({
        mapId: e,
        category: "trade-area",
        bucket: o.length,
        layerGroupId: t
      }), a = {
        ...l,
        paletteColors: [...l.paletteColors].reverse()
      }, s = b(a, o), { layerColor: p, layerGradient: d } = v({
        items: s,
        type: "walk_time",
        paletteColors: a.paletteColors
      }), m = g({ items: s, type: "walk_time" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "walk_time",
          name: "Walk Time",
          description: m,
          layerColor: p,
          layerGradient: d,
          visible: !0,
          fetchFilter: {
            timeSelected: o,
            entity_id: r,
            entity_type: i
          },
          visualFilter: {
            ...De,
            palette: a,
            items: s
          }
        }
      });
    },
    [c]
  ), te = n(
    ({
      mapId: e,
      layerGroupId: t,
      timeSelected: o,
      entity_id: r,
      entity_type: i
    }) => {
      const l = T({
        mapId: e,
        category: "trade-area",
        bucket: o.length,
        layerGroupId: t
      }), a = {
        ...l,
        paletteColors: [...l.paletteColors].reverse()
      }, s = b(a, o), { layerColor: p, layerGradient: d } = v({
        items: s,
        type: "drive_time",
        paletteColors: a.paletteColors
      }), m = g({ items: s, type: "drive_time" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "drive_time",
          name: "Drive Time",
          description: m,
          layerColor: p,
          layerGradient: d,
          visible: !0,
          fetchFilter: {
            timeSelected: o,
            entity_id: r,
            entity_type: i
          },
          visualFilter: {
            ...Fe,
            palette: a,
            items: s
          }
        }
      });
    },
    [c]
  ), oe = n(
    ({
      mapId: e,
      layerGroupId: t,
      boundaryType: o = "polygon"
    }) => {
      const r = T({
        mapId: e,
        category: "trade-area",
        bucket: 1,
        layerGroupId: t
      }), i = {
        ...r,
        paletteColors: [...r.paletteColors].reverse()
      }, l = [70], a = b(
        i,
        l
      ), { layerColor: s, layerGradient: p } = v({
        items: a,
        type: "tta",
        paletteColors: i.paletteColors
      }), d = g({ items: a, type: "tta" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "tta",
          name: "True Trade Area",
          description: d,
          layerColor: s,
          layerGradient: p,
          visible: !0,
          fetchFilter: {
            ...A,
            boundaryType: o,
            visualizationType: "choropleth",
            numberOfVisitsSelected: l
          },
          visualFilter: {
            ...V,
            palette: i,
            items: a
          }
        }
      });
    },
    [c]
  ), re = n(
    ({
      mapId: e,
      layerGroupId: t,
      tagId: o
    }) => {
      const r = T({
        mapId: e,
        category: "trade-area",
        bucket: 1,
        layerGroupId: t
      }), i = {
        ...r,
        paletteColors: [...r.paletteColors].reverse()
      }, l = [70], a = b(
        i,
        l
      ), { layerColor: s, layerGradient: p } = v({
        items: a,
        type: "tta",
        paletteColors: i.paletteColors
      }), d = g({ items: a, type: "tta" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "tta",
          name: "True Trade Area",
          description: d,
          layerColor: s,
          layerGradient: p,
          visible: !0,
          fetchFilter: {
            ...A,
            entity_id: o,
            entity_type: "tags",
            boundaryType: "cbgs",
            numberOfVisitsSelected: l
          },
          visualFilter: {
            ...V,
            palette: i,
            items: a
          }
        }
      });
    },
    [c]
  ), ie = n(
    ({
      mapId: e,
      layerGroupId: t,
      visualizationType: o = "choropleth",
      boundaryType: r = "polygon",
      polygonMiRadius: i = 50,
      minVisits: l = 1,
      visitorsOrigin: a = "home",
      metric: s = "visits",
      numberOfVisitsSelected: p
    }) => {
      const d = T({
        mapId: e,
        category: "trade-area",
        bucket: p.length,
        layerGroupId: t
      }), m = {
        ...d,
        paletteColors: [...d.paletteColors].reverse()
      }, y = b(
        m,
        p
      ), { layerColor: D, layerGradient: M } = v({
        items: y,
        type: "tta",
        paletteColors: m.paletteColors
      });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "tta",
          name: "True Trade Area",
          description: g({ items: y, type: "tta" }),
          layerColor: D,
          layerGradient: M,
          visible: !0,
          fetchFilter: {
            visualizationType: o,
            boundaryType: r,
            polygonMiRadius: i,
            minVisits: l,
            visitorsOrigin: a,
            metric: s,
            numberOfVisitsSelected: p
          },
          visualFilter: {
            ...V,
            palette: m,
            items: y
          }
        }
      });
    },
    [c]
  ), ae = n(
    ({
      mapId: e,
      layerGroupId: t,
      visitorsOrigin: o = "home",
      metric: r = "visits",
      minVisits: i = 1
    }) => {
      const { layerColor: l, layerGradient: a } = v({
        items: [],
        type: "tta_heat_map",
        paletteColors: w.palette.paletteColors
      }), s = g({ items: [], type: "tta_heat_map" });
      return c({
        mapId: e,
        layerGroupId: t,
        subLayerConfig: {
          renderType: "tta_heat_map",
          name: "True Trade Area Heat Map",
          description: s,
          layerColor: l,
          layerGradient: a,
          visible: !0,
          fetchFilter: {
            visitorsOrigin: o,
            metric: r,
            minVisits: i
          },
          visualFilter: {
            ...w
          }
        }
      });
    },
    [c]
  ), le = n(
    ({
      mapId: e,
      layerGroupId: t,
      layerType: o,
      fetchFilter: r,
      visualFilter: i
    }) => c({
      mapId: e,
      layerGroupId: t,
      subLayerConfig: {
        renderType: o,
        name: void 0,
        description: void 0,
        layerColor: void 0,
        visible: !0,
        fetchFilter: r ?? Se[o],
        visualFilter: i ?? Be[o]
      }
    }),
    [c]
  ), se = n(
    ({ mapId: e, chainId: t }) => {
      const o = h({
        mapId: e,
        poiId: t,
        poiType: "chain"
      }), r = O(e);
      return c({
        mapId: e,
        layerGroupId: o,
        subLayerConfig: {
          renderType: "chain-venues",
          name: "Store Locations",
          fetchFilter: fe,
          visualFilter: {
            ...Ce,
            palette: r.palette,
            pinPalette: r.palette
          },
          layerColor: r.color,
          description: void 0,
          visible: !0
        }
      });
    },
    [h, c]
  ), ne = n(
    ({
      mapId: e,
      poiId: t,
      poiType: o,
      name: r,
      description: i,
      addBoundaryLayer: l
    }) => {
      const a = h({
        mapId: e,
        poiId: t,
        poiType: o,
        name: r,
        description: i
      });
      f({
        mapId: e,
        layerGroupId: a,
        name: "Market Callout Box",
        poiCalloutBoxConfig: {
          showMetricsVisits: !1,
          showDaytimePopulation: !0
        },
        boundaryPolygonLayerName: "Market Boundary",
        boundaryPolygonVisualFilter: {
          fillVisible: !1
        },
        addBoundaryLayer: l
      });
    },
    [h, f]
  ), pe = n(
    (e) => {
      B(e);
    },
    [B]
  ), ue = n(
    (e) => {
      C(e);
    },
    [C]
  ), ce = n(
    ({ mapId: e, layerGroupId: t }) => {
      var i, l, a;
      const o = L.getState().maps;
      Object.keys(
        ((a = (l = (i = o == null ? void 0 : o[e]) == null ? void 0 : i.layerGroupConfig) == null ? void 0 : l[t]) == null ? void 0 : a.subLayerConfig) || {}
      ).forEach((s) => {
        F({ mapId: e, layerId: s });
      }), F({ mapId: e, layerId: t }), k({ mapId: e, layerGroupId: t });
    },
    [k, F]
  ), de = n(
    ({ mapId: e, layerGroupId: t, subLayerId: o }) => {
      x({ mapId: e, layerGroupId: t, subLayerId: o }), F({ mapId: e, layerId: o });
    },
    [x, F]
  );
  return {
    addPOI: h,
    addCallout: f,
    addCustomPOI: J,
    addNearby: z,
    addNearmap: R,
    addTextbox: $,
    addThematicLayer: I,
    addVehicleTrafficVolume: Y,
    addStaticGeojson: K,
    addLayerGroup: u,
    addSubLayer: c,
    updateSubLayer: C,
    addLayerByTradeType: le,
    updateLayerGroup: pe,
    updateSubLayerByType: ue,
    deleteSubLayer: de,
    deleteLayerGroup: ce,
    setCombinedLayersStatus: U,
    setCombinedLayersData: H,
    addChainGroupLayer: se,
    addShoppingCenterCallout: W,
    deleteShoppingCenterCallout: E,
    addDrawPolygonGeojson: Q,
    addTagsLayer: X,
    setLayersData: j,
    addDistanceInMilesTA: Z,
    addWalkTimeTA: ee,
    addDriveTimeTA: te,
    addTTA: ie,
    addTTAHeatMap: ae,
    addChainTTA: oe,
    addTagTTA: re,
    addMarketLayer: ne,
    ...q
  };
};
export {
  Wo as usePLMapboxLayersActions
};
//# sourceMappingURL=index.es13.js.map
